export default __webpack_public_path__ + "static/media/target-leads.e062ea4e.svg";